export default "__VITE_ASSET__Vcz8lWn6__"